import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

export default function AdminLogin() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError(""); setLoading(true);
    try {
      await login(email, password);
      navigate("/admin");
    } catch (err) {
      const d = err.response?.data?.detail;
      setError(typeof d === "string" ? d : "Login failed. Check your email and password.");
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen grid lg:grid-cols-2 bg-paper">
      <div className="hidden lg:block relative overflow-hidden bg-ink">
        <img src="https://images.unsplash.com/photo-1595024600400-2a49b9fce270?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzF8MHwxfHNlYXJjaHw0fHx3aGVhdCUyMGZpZWxkfGVufDB8fHx8MTc4NjQ4MzQ4NHww&ixlib=rb-4.1.0&q=85" alt="" className="w-full h-full object-cover opacity-80" />
        <div className="absolute bottom-10 left-10 text-paper">
          <span className="label text-wheat">Prairie Prints MT</span>
          <h1 className="font-serif text-5xl tracking-tight mt-2">Studio</h1>
        </div>
      </div>
      <div className="flex items-center justify-center px-6 py-16">
        <form onSubmit={submit} className="w-full max-w-sm" data-testid="admin-login-form">
          <img src="/logo.jpg" alt="Prairie Prints MT" className="h-24 w-24 rounded-full object-cover mix-blend-multiply mb-6" />
          <span className="label text-brick">Admin access</span>
          <h2 className="font-serif text-4xl tracking-tight mt-2 mb-8">Welcome back, Mary.</h2>
          {error && <p className="label text-brick mb-4" data-testid="login-error">{error}</p>}
          <label className="label text-stone">Email</label>
          <input data-testid="login-email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} required
            className="w-full border border-line bg-paper px-4 py-3 mt-1 mb-5 outline-none focus:border-ink transition-colors" />
          <label className="label text-stone">Password</label>
          <input data-testid="login-password" type="password" value={password} onChange={(e) => setPassword(e.target.value)} required
            className="w-full border border-line bg-paper px-4 py-3 mt-1 mb-8 outline-none focus:border-ink transition-colors" />
          <button data-testid="login-submit" type="submit" disabled={loading}
            className="w-full label bg-ink text-paper py-4 hover:bg-brick transition-colors duration-300 disabled:opacity-60">
            {loading ? "Signing in…" : "Sign in"}
          </button>
        </form>
      </div>
    </div>
  );
}
